import { Product } from "callable-data-objects";
import { useProductTable } from "Hooks/Endpoints";
import React, { Fragment } from "react";
import { Button, Card, Grid, Header, Input, Table } from "semantic-ui-react";

const ProductTableProducts = () => {
  const {
    productTable,
    selectProduct,
    searchProduct,
    setSearchProduct,
    createProductTableProduct,
  } = useProductTable();

  const products = productTable.products
    .filter(
      (r: Product) =>
        !searchProduct ||
        r.name.indexOf(searchProduct) > -1 ||
        r.description.indexOf(searchProduct) > -1
    )
    .splice(0, 20);

  return (
    <Fragment>
      <Header as="h3">Products</Header>
      <Card fluid>
        <Card.Content>
          <Grid stackable padded>
            <Grid.Column width={14}>
              <Input
                value={searchProduct}
                placeholder="Search..."
                onChange={(value, data) => setSearchProduct(data.value)}
                icon="search"
              />
            </Grid.Column>
            <Grid.Column width={2} style={{ textAlign: "right" }}>
              <Button primary onClick={() => createProductTableProduct()}>
                Create
              </Button>
            </Grid.Column>
          </Grid>

          <Table celled padded stackable>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell singleLine>ID</Table.HeaderCell>
                <Table.HeaderCell singleLine>Name</Table.HeaderCell>
                <Table.HeaderCell singleLine>Description</Table.HeaderCell>
                <Table.HeaderCell singleLine>Category</Table.HeaderCell>
                <Table.HeaderCell singleLine>Type</Table.HeaderCell>
                <Table.HeaderCell singleLine>Price</Table.HeaderCell>
                <Table.HeaderCell width={1}>Actions</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {products.map((p: Product) => (
                <Table.Row key={`tr-ddi-${p.id}`}>
                  <Table.Cell singleLine>{p.id}</Table.Cell>
                  <Table.Cell singleLine>{p.name}</Table.Cell>
                  <Table.Cell singleLine>{p.description}</Table.Cell>
                  <Table.Cell singleLine>{p.category}</Table.Cell>
                  <Table.Cell singleLine>{p.type}</Table.Cell>
                  <Table.Cell singleLine>{p.price}</Table.Cell>
                  <Table.Cell textAlign="left">
                    <Button
                      primary
                      size="tiny"
                      onClick={() => selectProduct(p.id)}
                    >
                      Select
                    </Button>
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </Card.Content>
      </Card>
    </Fragment>
  );
};

export default ProductTableProducts;
